import Section from "../Section";
export default class FeaturedMenu extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

  }
}
